import { makeStyles } from '@material-ui/core';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    loadingWrapper: {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(1),
    },
    loading: {
      color: COLORS.gray.gray50,
    },
    chipsWrapper: {
      display: 'flex',
      flexFlow: 'row wrap',
      gap: theme.spacing(1),
    },
    chip: {
      maxWidth: '100%',
      cursor: 'pointer',
      margin: 0,
    },
    toolLabel: {
      fontSize: theme.typography.pxToRem(12),
      lineHeight: theme.typography.pxToRem(14),
    },
    chipLabel: {
      display: 'flex',
      alignItems: 'center',
      fontSize: theme.typography.pxToRem(12),
      lineHeight: theme.typography.pxToRem(14),
    },
    iconExpand: {
      marginRight: theme.spacing(-0.25),
      fontSize: theme.typography.pxToRem(16),
      color: COLORS.gray.gray30,
    },
    moreMenu: {
      border: theme.shape.borderGray70,
      width: 250,
      maxHeight: 144,
    },
    menuItem: {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
      minHeight: 30,
    },
  }),
  { name: 'FreestyleTools' }
);
